/* ============================================================================
   Philip Karto — Neverfull collection  ·  pk-neverfull-collection.js
   · edition tabs (All / PK.01 / PK.02 / PK.03 …) filter the colour-variant cards
   · "Refine" drawer (desktop) / bottom sheet (mobile): Edition, Size, Price, Availability
     multi-select pills (OR inside a group, AND across groups)
   · Sort: the store's own collection sort options (Featured, Best selling, A–Z, Z–A,
     price, date), shown in the theme's "Sort by" popover (x-popover + x-listbox, as on the
     default collection page). Best selling order is fetched once from /collections/all.
   · configurable promo cards ("Promo card" blocks) are injected BETWEEN the product cards,
     in the row / side / width chosen per block in the theme editor
   · wishlist hearts (localStorage)
   ========================================================================== */
(function () {
  'use strict';

  var LABELS = {
    filter: 'Filter', refine: 'Refine', close: 'Close', clear: 'Clear', show: 'Show', works: 'works',
    edition: 'Edition', size: 'Size', price: 'Price', avail: 'Availability',
    under: 'Under', over: 'and over',
    sort: 'Sort',
    pieces: 'pieces shown'
  };
  var WISH_KEY = 'pk_wishlist';

  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

  function readWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || {}; } catch (e) { return {}; } }
  function writeWish(w) { try { localStorage.setItem(WISH_KEY, JSON.stringify(w)); } catch (e) {} }

  var SORT_FALLBACK = [
    { v: 'manual', l: 'Featured' }, { v: 'best-selling', l: 'Best selling' },
    { v: 'title-ascending', l: 'Alphabetically, A-Z' }, { v: 'title-descending', l: 'Alphabetically, Z-A' },
    { v: 'price-ascending', l: 'Price, low to high' }, { v: 'price-descending', l: 'Price, high to low' },
    { v: 'created-ascending', l: 'Date, old to new' }, { v: 'created-descending', l: 'Date, new to old' }
  ];
  function readSortItems(root) {
    var el = qs(root, 'script[data-pk-sort-options]'), list;
    try { list = JSON.parse(el.textContent).filter(function (o) { return o.v && o.l; }); } catch (e) {}
    return list && list.length ? list : SORT_FALLBACK;
  }

  /* Promo card config, read from the data-attributes printed by snippets/pk-nf-promo.liquid */
  function readPromo(el, order) {
    var d = el.dataset;
    return {
      el: el,
      order: order,                                        // editor order = tie-breaker
      showOn: d.showOn || 'all',                           // all | editions | every | tab
      edition: d.edition || '',                            // collection handle (tab) this card belongs to
      sw: d.switch || '',                                  // tab to open on click from "All works" ('' = just follow the link)
      alsoAll: d.alsoAll === 'true',                       // tab card that also shows on "All works"
      row: Math.max(0, parseInt(d.row, 10) || 0),          // desktop row, 0 = not placed by row
      align: d.align === 'left' ? 'left' : 'right',
      span: Math.max(1, parseInt(d.span, 10) || 2),        // desktop width in columns
      mobileRow: Math.max(0, parseInt(d.mobileRow, 10) || 0), // mobile row, 0 = hidden
      fill: d.fill === 'true'                              // may complete a short last row
    };
  }

  function PKNeverfull(root) {
    if (root.__pkNf) return;
    root.__pkNf = this;
    var self = this;

    this.root = root;
    this.grid = qs(root, '[data-pk-grid]');
    this.empty = qs(root, '[data-pk-empty]');
    this.live = qs(root, '[data-pk-live]');
    this.bar = qs(root, '[data-pk-bar]');
    this.tabs = qsa(root, '[data-pk-tab]');
    this.cards = qsa(this.grid, '[data-pk-card]');
    this.cards.forEach(function (c, i) { c.__idx = i; });

    var tpl = qs(root, 'template[data-pk-promo-templates]');
    this.promos = root.dataset.showPromos === 'true' && tpl ? qsa(tpl.content, '[data-pk-promo]').map(readPromo) : [];

    var active = this.tabs.filter(function (t) { return t.classList.contains('is-active'); })[0];
    var first = active && active.dataset.pkTab !== 'all' ? [active.dataset.pkTab] : [];
    this.sortItems = readSortItems(root);
    this.state = { edition: first, size: [], price: [], avail: [], sort: this.sortItems[0].v };

    var fromUrl = new URLSearchParams(location.search).get('edition');
    if (fromUrl && this.tabs.some(function (t) { return t.dataset.pkTab === fromUrl; })) this.state.edition = [fromUrl];

    this.bindTabs();
    this.buildTools();
    this.buildRefine();
    this.buildPill();
    var clear = qs(root, '[data-pk-clear]');
    if (clear) clear.addEventListener('click', function () { self.clearFilters(); });
    this.bindWishlist();
    this.bindPromoClicks();

    var t;
    this.cols = 0;
    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 989px)');
      var onMq = function () { if (self.colCount() !== self.cols) self.layout(); };
      if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    }
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { if (self.colCount() !== self.cols) self.layout(); }, 120);
    });

    this.update();
  }

  /* ── Tabs (single edition shortcut for the Edition filter) ───────────── */
  PKNeverfull.prototype.bindTabs = function () {
    var self = this;
    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { self.setEdition(tab.dataset.pkTab); });
    });
  };
  PKNeverfull.prototype.syncTabs = function () {
    var ed = this.state.edition;
    this.tabs.forEach(function (t) {
      var on = t.dataset.pkTab === 'all' ? ed.length === 0 : ed.length === 1 && ed[0] === t.dataset.pkTab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  };
  PKNeverfull.prototype.syncUrl = function () {
    try {
      var u = new URL(location.href), ed = this.state.edition;
      if (ed.length === 1) u.searchParams.set('edition', ed[0]); else u.searchParams.delete('edition');
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  };
  PKNeverfull.prototype.setEdition = function (ed, opts) {
    var next = ed === 'all' ? [] : [ed];
    if (next.join() === this.state.edition.join()) return;
    this.state.edition = next;
    this.update({ fade: true, scroll: opts && opts.scroll });
  };

  /* Re-render after any state change */
  PKNeverfull.prototype.update = function (opts) {
    var self = this;
    this.syncTabs();
    this.syncUrl();
    this.paintControls();
    if (!opts || !opts.fade) { this.layout(); return; }
    this.grid.classList.add('is-switching');
    clearTimeout(this.__fadeT);
    this.__fadeT = setTimeout(function () {
      self.layout();
      self.grid.classList.remove('is-switching');
      if (opts.scroll) {
        var top = self.bar.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(self.root).getPropertyValue('--pk-sticky-top'), 10) || 0);
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }, 180);
  };
  PKNeverfull.prototype.activeCount = function () {
    var s = this.state;
    return s.edition.length + s.size.length + s.price.length + s.avail.length;
  };
  PKNeverfull.prototype.clearFilters = function () {
    var s = this.state;
    s.edition = []; s.size = []; s.price = []; s.avail = [];
    this.update({ fade: true });
  };

  /* ── Facet definitions ──────────────────────────────────────────────── */
  PKNeverfull.prototype.facets = function () {
    var root = this.root, cards = this.cards, out = [];

    var eds = this.tabs.filter(function (t) { return t.dataset.pkTab !== 'all'; })
      .map(function (t) { return { v: t.dataset.pkTab, l: t.dataset.pkLabel || t.textContent.trim() }; });
    if (eds.length > 1) out.push({ key: 'edition', name: LABELS.edition, items: eds });

    // sizes: configured order first, then anything else found on the cards
    var sizes = (root.dataset.sizes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    cards.forEach(function (c) {
      c.dataset.sizes.split(',').forEach(function (s) { if (s && sizes.indexOf(s) === -1) sizes.push(s); });
    });
    if (sizes.length > 1) out.push({ key: 'size', name: LABELS.size, items: sizes.map(function (s) { return { v: s, l: s }; }) });

    var steps = (root.dataset.priceSteps || '').split(',').map(function (s) { return parseFloat(s); }).filter(function (n) { return !isNaN(n); });
    if (steps.length) {
      var cur = root.dataset.currency || 'USD', fmt;
      try { fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }); }
      catch (e) { fmt = { format: function (n) { return String(n); } }; }
      var items = [{ v: '0-' + steps[0] * 100, l: LABELS.under + ' ' + fmt.format(steps[0]) }];
      for (var i = 0; i < steps.length - 1; i++) items.push({ v: steps[i] * 100 + '-' + steps[i + 1] * 100, l: fmt.format(steps[i]) + ' – ' + fmt.format(steps[i + 1]) });
      items.push({ v: steps[steps.length - 1] * 100 + '-', l: fmt.format(steps[steps.length - 1]) + ' ' + LABELS.over });
      out.push({ key: 'price', name: LABELS.price, items: items });
    }

    if (root.dataset.showAvailability === 'true') {
      out.push({ key: 'avail', name: LABELS.avail, items: [
        { v: 'true', l: root.dataset.labelAvailable || 'Available' },
        { v: 'false', l: root.dataset.labelUnavailable || 'Upon request' }
      ] });
    }
    return out;
  };

  /* ── Toolbar (desktop): Filter → Refine drawer · Sort popover ─────────── */
  PKNeverfull.prototype.buildTools = function () {
    var self = this, host = qs(this.root, '[data-pk-tools]');
    this.menus = [];
    this.filterBtns = [];
    this.sortLabels = [];
    if (!host) return;

    var fb = document.createElement('button');
    fb.type = 'button'; fb.className = 'pk-nf-menu__btn pk-nf__filter-btn';
    fb.setAttribute('aria-haspopup', 'dialog');
    fb.addEventListener('click', function () { self.openRefine(fb); });
    host.insertBefore(fb, host.firstChild);
    this.filterBtns.push(fb);

    // Sort: theme popover from the Liquid; our own dropdown only if the theme component is missing
    this.sortPopover = qs(host, '[data-pk-sort-popover]');
    if (this.sortPopover) {
      this.sortLabels.push(qs(host, '[data-pk-sort-btn]'));
      this.sortPopover.addEventListener('listbox:change', function (e) { self.setSort(e.detail.value); });
      window.addEventListener('load', function () {
        if (window.customElements.get('x-popover')) return;
        self.sortPopover.parentNode.remove();
        self.sortPopover = null;
        self.addMenu(host, 'sort', LABELS.sort, self.sortItems, { showValue: true, dropdown: true });
        self.paintControls();
      });
    } else {
      this.addMenu(host, 'sort', LABELS.sort, this.sortItems, { showValue: true, dropdown: true });
    }

    document.addEventListener('click', function (e) { if (!self.root.contains(e.target) || !e.target.closest('.pk-nf-menu')) self.closeMenus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.closeMenus(); });
  };

  /* Desktop popover: same light panel + pills as the mockup's "Refine" sheet */
  PKNeverfull.prototype.addMenu = function (host, key, label, items, opts) {
    var self = this, multi = opts && opts.multi;
    var wrap = document.createElement('div'); wrap.className = 'pk-nf-menu';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'pk-nf-menu__btn'; btn.setAttribute('aria-haspopup', 'true'); btn.setAttribute('aria-expanded', 'false');
    var list = document.createElement('div'); list.className = 'pk-nf-menu__list' + (opts && opts.dropdown ? ' pk-nf-menu__list--dropdown' : ''); list.hidden = true;
    list.setAttribute('role', 'group'); list.setAttribute('aria-label', label);

    var head = document.createElement('div'); head.className = 'pk-nf-menu__head';
    var title = document.createElement('span'); title.className = 'pk-nf-menu__title'; title.textContent = label;
    head.appendChild(title);
    var clear = null;
    if (multi) {
      clear = document.createElement('button');
      clear.type = 'button'; clear.className = 'pk-nf-menu__clear'; clear.textContent = LABELS.clear;
      clear.addEventListener('click', function () { self.state[key] = []; self.update({ fade: true }); });
      head.appendChild(clear);
    }
    var pills = document.createElement('div'); pills.className = 'pk-nf-menu__pills';
    list.appendChild(head); list.appendChild(pills);

    function paint() {
      var s = self.state;
      if (multi) {
        var sel = s[key];
        btn.textContent = sel.length
          ? label + ' · ' + items.filter(function (i) { return sel.indexOf(i.v) !== -1; }).map(function (i) { return i.l; }).join(', ')
          : label;
        btn.classList.toggle('is-set', sel.length > 0);
        clear.disabled = !sel.length;
        qsa(pills, 'button').forEach(function (b) {
          var v = b.dataset.v, on = sel.indexOf(v) !== -1;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          // grey out options that would show nothing (other filters applied)
          var probe = {}; for (var k in s) probe[k] = s[k];
          probe[key] = [v];
          b.disabled = !on && !self.cards.some(function (c) { return self.matches(c, probe); });
        });
      } else {
        var cur = items.filter(function (i) { return i.v === s[key]; })[0] || items[0];
        btn.textContent = opts && opts.showValue ? label + ' · ' + cur.l : label;
        qsa(pills, 'button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.v === cur.v ? 'true' : 'false'); });
      }
    }
    items.forEach(function (it) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pk-nf-menu__item'; b.dataset.v = it.v; b.textContent = it.l;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        if (multi) {
          // toggle; the popover stays open so several values can be picked
          var arr = self.state[key], i = arr.indexOf(it.v);
          if (i === -1) arr.push(it.v); else arr.splice(i, 1);
          self.update({ fade: true });
        } else {
          self.closeMenus();
          self.setSort(it.v);
        }
      });
      pills.appendChild(b);
    });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = list.hidden;
      self.closeMenus();
      list.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    wrap.appendChild(btn); wrap.appendChild(list); host.appendChild(wrap);
    this.menus.push({ btn: btn, list: list, paint: paint });
  };
  PKNeverfull.prototype.closeMenus = function () {
    (this.menus || []).forEach(function (m) { m.list.hidden = true; m.btn.setAttribute('aria-expanded', 'false'); });
  };

  /* ── Mobile: floating "Filter | Sort" pill, stays on screen while the grid is in view (incl. while scrolling) ── */
  PKNeverfull.prototype.buildPill = function () {
    var self = this, pill = document.createElement('div');
    pill.className = 'pk-nf-pill';
    pill.innerHTML = '<button type="button" class="pk-nf-pill__btn" data-f></button><button type="button" class="pk-nf-pill__btn" data-s></button>';
    var f = qs(pill, '[data-f]'), s = qs(pill, '[data-s]');
    f.setAttribute('aria-haspopup', 'dialog'); s.setAttribute('aria-haspopup', 'dialog');
    f.addEventListener('click', function () { self.openRefine(f); });
    if (this.sortPopover) s.setAttribute('aria-controls', this.sortPopover.id);
    else s.addEventListener('click', function () { self.openRefine(s, 'sort'); });
    this.filterBtns.push(f);
    this.sortLabels.push(s);
    this.root.appendChild(pill);
    this.pill = pill;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        pill.classList.toggle('is-visible', entries[0].isIntersecting);
      }).observe(this.grid);
    } else {
      pill.classList.add('is-visible');
    }
  };

  /* ── Refine drawer / sheet ──────────────────────────────────────────── */
  PKNeverfull.prototype.buildRefine = function () {
    var self = this, uid = 'pk-refine-' + (this.root.dataset.sectionId || Math.random().toString(36).slice(2));
    var el = document.createElement('div');
    el.className = 'pk-nf-refine';
    el.hidden = true;
    el.innerHTML =
      '<div class="pk-nf-refine__overlay" data-close></div>' +
      '<div class="pk-nf-refine__panel" role="dialog" aria-modal="true" aria-labelledby="' + uid + '" tabindex="-1">' +
        '<span class="pk-nf-refine__handle" aria-hidden="true"></span>' +
        '<div class="pk-nf-refine__head"><h2 class="pk-nf-refine__title" id="' + uid + '">' + LABELS.refine + '</h2>' +
        '<button type="button" class="pk-nf-refine__close" data-close>' + LABELS.close + '</button></div>' +
        '<div class="pk-nf-refine__body" data-body></div>' +
        '<div class="pk-nf-refine__foot">' +
          '<button type="button" class="pk-nf-refine__btn pk-nf-refine__btn--ghost" data-clear>' + LABELS.clear + '</button>' +
          '<button type="button" class="pk-nf-refine__btn" data-close data-apply></button>' +
        '</div>' +
      '</div>';

    var body = qs(el, '[data-body]');
    this.pills = [];
    var groups = this.facets();
    if (!this.sortPopover) groups.push({ key: 'sort', name: LABELS.sort, items: this.sortItems, single: true });
    groups.forEach(function (fc) {
      var g = document.createElement('fieldset');
      g.className = 'pk-nf-refine__group' + (fc.key === 'sort' ? ' pk-nf-refine__group--sort' : '');
      g.dataset.group = fc.key;
      var lg = document.createElement('legend'); lg.className = 'pk-nf-refine__legend'; lg.textContent = fc.name;
      var wrap = document.createElement('div'); wrap.className = 'pk-nf-refine__pills';
      fc.items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pk-nf-refine__pill'; b.textContent = it.l;
        b.addEventListener('click', function () {
          if (fc.single) { self.setSort(it.v); return; }
          else {
            var arr = self.state[fc.key], i = arr.indexOf(it.v);
            if (i === -1) arr.push(it.v); else arr.splice(i, 1);
          }
          self.update();
        });
        self.pills.push({ key: fc.key, v: it.v, single: fc.single, el: b });
        wrap.appendChild(b);
      });
      g.appendChild(lg); g.appendChild(wrap); body.appendChild(g);
    });

    qsa(el, '[data-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeRefine(); }); });
    qs(el, '[data-clear]').addEventListener('click', function () { self.clearFilters(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); self.closeRefine(); return; }
      if (e.key !== 'Tab') return;
      var f = qsa(el, 'button:not([disabled])').filter(function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    // copy the section colour tokens: the drawer lives on <body> so it escapes the sticky/stacking contexts
    el.setAttribute('style', this.root.getAttribute('style') || '');
    document.body.appendChild(el);
    this.refine = el;
    this.applyBtn = qs(el, '[data-apply]');
  };
  PKNeverfull.prototype.openRefine = function (trigger, focusGroup) {
    var el = this.refine;
    this.closeMenus();
    this.lastTrigger = trigger;
    el.hidden = false;
    document.documentElement.classList.add('pk-nf-lock');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var g = focusGroup && qs(el, '[data-group="' + focusGroup + '"]');
      if (g) { g.scrollIntoView({ block: 'nearest' }); var p = qs(g, 'button'); if (p) p.focus({ preventScroll: true }); }
      else qs(el, '.pk-nf-refine__close').focus({ preventScroll: true });
    });
    clearTimeout(this.__closeT);
    this.paintControls();
  };
  PKNeverfull.prototype.closeRefine = function () {
    var el = this.refine;
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('pk-nf-lock');
    this.__closeT = setTimeout(function () { el.hidden = true; }, 420);
    if (this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
  };

  /* Filter button labels, pill states, "Show N works", disabled empty options */
  PKNeverfull.prototype.paintControls = function () {
    var self = this, s = this.state, n = this.activeCount();
    var sortCur = this.sortItems.filter(function (i) { return i.v === s.sort; })[0] || this.sortItems[0];

    (this.filterBtns || []).forEach(function (b) {
      b.textContent = n ? LABELS.filter + ' (' + n + ')' : LABELS.filter;
      b.classList.toggle('is-set', n > 0);
    });
    (this.sortLabels || []).forEach(function (b) { b.textContent = LABELS.sort + ' · ' + sortCur.l; });
    (this.menus || []).forEach(function (m) { m.paint(); });

    if (!this.pills) return;
    this.pills.forEach(function (p) {
      var on = p.single ? s[p.key] === p.v : s[p.key].indexOf(p.v) !== -1;
      p.el.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (p.single) return;
      // would picking this option leave anything to show? (other groups applied, this group = just this value)
      var probe = {}; for (var k in s) probe[k] = s[k];
      probe[p.key] = [p.v];
      var any = self.cards.some(function (c) { return self.matches(c, probe); });
      p.el.disabled = !on && !any;
    });
    var count = this.visibleCards().length;
    this.applyBtn.textContent = LABELS.show + ' ' + count + ' ' + LABELS.works;
    qs(this.refine, '[data-clear]').disabled = n === 0;
  };

  /* ── Sorting ────────────────────────────────────────────────────────── */
  PKNeverfull.prototype.setSort = function (v) {
    var self = this;
    this.state.sort = v;
    if (v !== 'best-selling' || this.bestLoaded) { this.update({ fade: true }); return; }
    this.paintControls();
    this.loadBestSelling().then(function () { if (self.state.sort === 'best-selling') self.update({ fade: true }); });
  };
  /* Store-wide best-selling order: sections/pk-sort-order.liquid prints product ids of /collections/all */
  PKNeverfull.prototype.loadBestSelling = function () {
    var self = this;
    if (this.__bestReq) return this.__bestReq;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    this.__bestReq = fetch(root + 'collections/all?sort_by=best-selling&section_id=pk-sort-order')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-pk-order[^>]*>([\s\S]*?)<\/script>/), ids = m ? JSON.parse(m[1]) : [];
        var rank = {};
        ids.forEach(function (id, i) { rank[id] = i; });
        self.cards.forEach(function (c) { var r = rank[c.dataset.productId]; c.__best = r === undefined ? 1e6 + c.__idx : r; });
      })
      .catch(function () { self.cards.forEach(function (c) { c.__best = c.__idx; }); })
      .then(function () { self.bestLoaded = true; });
    return this.__bestReq;
  };

  /* ── Filtering / sorting ────────────────────────────────────────────── */
  PKNeverfull.prototype.matches = function (c, s) {
    if (s.edition.length && s.edition.indexOf(c.dataset.edition) === -1) return false;
    if (s.size.length && !s.size.some(function (z) { return c.dataset.sizes.indexOf(',' + z + ',') !== -1; })) return false;
    if (s.avail.length && s.avail.indexOf(c.dataset.available) === -1) return false;
    if (s.price.length) {
      var p = parseInt(c.dataset.price, 10);
      var inRange = s.price.some(function (r) {
        r = r.split('-');
        var lo = r[0] ? parseInt(r[0], 10) : 0, hi = r[1] ? parseInt(r[1], 10) : Infinity;
        return p >= lo && p < hi;
      });
      if (!inRange) return false;
    }
    return true;
  };
  PKNeverfull.prototype.visibleCards = function () {
    var self = this, s = this.state;
    var out = this.cards.filter(function (c) { return self.matches(c, s); });
    var num = function (c, k) { return parseFloat(c.dataset[k]) || 0; };
    var by = {
      'manual': function (a, b) { return a.__idx - b.__idx; },
      'best-selling': function (a, b) { return ((a.__best === undefined ? a.__idx : a.__best) - (b.__best === undefined ? b.__idx : b.__best)) || a.__idx - b.__idx; },
      'title-ascending': function (a, b) { return a.dataset.title.localeCompare(b.dataset.title) || a.__idx - b.__idx; },
      'title-descending': function (a, b) { return b.dataset.title.localeCompare(a.dataset.title) || a.__idx - b.__idx; },
      'price-ascending': function (a, b) { return num(a, 'price') - num(b, 'price') || a.__idx - b.__idx; },
      'price-descending': function (a, b) { return num(b, 'price') - num(a, 'price') || a.__idx - b.__idx; },
      'created-ascending': function (a, b) { return num(a, 'created') - num(b, 'created') || a.__idx - b.__idx; },
      'created-descending': function (a, b) { return num(b, 'created') - num(a, 'created') || a.__idx - b.__idx; }
    }[s.sort] || function (a, b) { return a.__idx - b.__idx; };
    return out.sort(by);
  };

  PKNeverfull.prototype.colCount = function () {
    // mobile / tablet = 2 columns, decided by the same breakpoint as the CSS (does not depend on
    // the stylesheet having finished loading when the layout runs)
    if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return 2;
    return Math.max(1, getComputedStyle(this.grid).gridTemplateColumns.split(' ').length);
  };

  /* Which promo cards belong on the tab / edition filter that is currently active */
  PKNeverfull.prototype.promosForState = function () {
    var eds = this.state.edition;
    return this.promos.filter(function (p) {
      switch (p.showOn) {
        case 'every':    return true;
        case 'editions': return eds.length > 0;
        case 'tab':      return (!!p.edition && eds.indexOf(p.edition) !== -1) || (p.alsoAll && eds.length === 0);
        default:         return eds.length === 0;          // 'all' → the "All works" tab only
      }
    });
  };

  /* Enlarge-first-product setting for the active tab ("All works" uses the section setting) */
  PKNeverfull.prototype.featureCfg = function () {
    var eds = this.state.edition, d = this.root.dataset, on, side;
    var tab = eds.length === 1 ? this.tabs.filter(function (t) { return t.dataset.pkTab === eds[0]; })[0] : null;
    if (tab) { on = tab.dataset.feature === 'true'; side = tab.dataset.featureSide; }
    else { on = d.featureAll === 'true'; side = d.featureAllSide; }
    return { on: on, side: side === 'right' ? 'right' : 'left' };
  };

  /* ── Layout: place promo cards between the products ───────────────────
     Every promo card (a slot inside a tab block, or a standalone "Promo card" block)
     says where it goes (see snippets/pk-nf-promo.liquid). Tab cards only show while their
     tab is open (or also on "All works" when ticked); several cards per tab are fine:

     Desktop (4 cols)   row N · side left/right · width 1–4 columns.
                        The row is completed with products:
                          row 2, right, 2 cols →  [p p PROMO PROMO]
                          row 4, left,  3 cols →  [PROMO PROMO PROMO p]
                          row 3, full row      →  [PROMO PROMO PROMO PROMO]
                        If fewer products are left than the row needs, the card widens
                        to close the gap (never an empty cell).
                        A card whose row is past the end of the grid is skipped, except
                        cards ticked "Complete a short last row", which fill a gap in the last row.
     Mobile  (2 cols)   row N, always full width. Row 0 = hidden on mobile.

     Rows are counted in the grid as shown (product rows + promo rows), after filters / sorting.
     An enlarged first product uses rows 1–2 on desktop (row 1 on mobile), so promo cards asked
     for those rows move to the first free row after it.
     Two cards asking for the same row: the second one moves to the next row.
  ──────────────────────────────────────────────────────────────────── */
  PKNeverfull.prototype.layout = function () {
    var self = this, grid = this.grid, vis = this.visibleCards(), cols = this.cols = this.colCount();

    qsa(grid, '.is-clone').forEach(function (n) { n.remove(); });

    var compact = cols < 3;                                 // mobile / tablet grid
    var pool = this.promosForState();
    function rowOf(p) { return compact ? p.mobileRow : p.row; }
    function clone(p, span) {
      var c = p.el.cloneNode(true);
      span = Math.max(1, Math.min(span, cols));
      c.classList.add('is-clone');
      c.classList.toggle('is-narrow', span === 1 && !compact);
      c.style.gridColumn = 'span ' + span;
      return c;
    }

    // forget the enlarged state of the previous layout
    this.cards.forEach(function (c) {
      c.classList.remove('is-featured', 'has-life');
      c.style.gridColumn = ''; c.style.gridRow = '';
    });

    var n = vis.length, seq = [], i = 0, row = 1, gap = 0, used = [];

    // ── Enlarged first product: 2 cols × 2 rows (desktop) / full width (mobile) ──
    var fc = this.featureCfg();
    if (fc.on && n) {
      var per = compact ? 0 : cols - 2;                      // products beside it, per row
      var need = per * 2;
      if (compact || n > need) {
        var big = vis[0], side = vis.slice(1, 1 + need);
        i = 1 + side.length;
        big.classList.add('is-featured');
        big.style.gridColumn = 'span ' + (compact ? cols : 2);
        if (!compact) big.style.gridRow = 'span 2';
        var life = qs(big, '.pk-nf-card__img--hover');
        if (life) { big.classList.add('has-life'); life.sizes = compact ? '100vw' : '50vw'; }
        if (compact || fc.side === 'left') { seq.push(big); seq = seq.concat(side); }
        else { seq = seq.concat(side.slice(0, per)); seq.push(big); seq = seq.concat(side.slice(per)); }
        row = compact ? 2 : 3;                                // it used up the first rows
      }
    }

    // ── Promo cards + remaining products ──
    var queue = pool.filter(function (p) { return rowOf(p) > 0; })
      .sort(function (a, b) { return (rowOf(a) - rowOf(b)) || (a.order - b.order); });

    while (i < n) {
      var p = queue.length && rowOf(queue[0]) <= row ? queue.shift() : null;
      if (p) {
        var span = compact ? cols : Math.min(p.span, cols);
        var beside = vis.slice(i, i + (cols - span));         // products sharing the row
        i += beside.length;
        var node = clone(p, cols - beside.length);            // widen if products ran out
        if (p.align === 'left' && !compact) { seq.push(node); seq = seq.concat(beside); }
        else { seq = seq.concat(beside); seq.push(node); }
        used.push(p);
        gap = 0;
      } else {
        var line = vis.slice(i, i + cols);
        i += line.length;
        seq = seq.concat(line);
        gap = cols - line.length;
      }
      row++;
    }

    // last row of products has gaps → a "complete a short last row" card closes it (desktop)
    if (gap > 0 && !compact) {
      var filler = pool.filter(function (p) { return p.fill && used.indexOf(p) === -1; })[0];
      if (filler) seq.push(clone(filler, gap));
    }

    var frag = document.createDocumentFragment();
    seq.forEach(function (node) { frag.appendChild(node); });
    this.cards.forEach(function (c) { c.hidden = vis.indexOf(c) === -1; if (c.hidden) frag.appendChild(c); });
    grid.appendChild(frag);

    this.empty.hidden = n > 0;
    if (this.__staggered) {
      vis.slice(0, 16).forEach(function (c, j) {
        c.classList.remove('is-in');
        c.style.animationDelay = (j * 40) + 'ms';
        void c.offsetWidth;
        c.classList.add('is-in');
      });
    }
    this.__staggered = true;
    this.syncHearts();
    if (this.live) this.live.textContent = n + ' ' + LABELS.pieces;
  };

  /* ── Promo click: All → switch tab · edition tab → open edition page ── */
  PKNeverfull.prototype.bindPromoClicks = function () {
    var self = this;
    this.grid.addEventListener('click', function (e) {
      var link = e.target.closest('[data-pk-promo-link]');
      if (!link || self.state.edition.length) return;
      var promo = link.closest('[data-pk-promo]');
      if (!promo || !promo.dataset.switch || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      self.setEdition(promo.dataset.switch, { scroll: true });
    });
  };

  /* ── Wishlist ───────────────────────────────────────────────────────── */
  PKNeverfull.prototype.bindWishlist = function () {
    var self = this;
    this.grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pk-heart]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var key = btn.closest('[data-pk-card]').dataset.wishKey, w = readWish();
      if (w[key]) delete w[key]; else w[key] = 1;
      writeWish(w);
      self.syncHearts();
      document.dispatchEvent(new CustomEvent('pk:wishlist-change', { detail: { keys: Object.keys(w), count: Object.keys(w).length } }));
    });
  };
  PKNeverfull.prototype.syncHearts = function () {
    var w = readWish();
    this.cards.forEach(function (c) {
      var b = qs(c, '[data-pk-heart]');
      if (b) b.setAttribute('aria-pressed', w[c.dataset.wishKey] ? 'true' : 'false');
    });
  };

  /* ── Boot (+ Shopify theme editor) ──────────────────────────────────── */
  function boot(scope) { qsa(scope || document, '[data-pk-nf]').forEach(function (el) { new PKNeverfull(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    qsa(e.target, '[data-pk-nf]').forEach(function (el) {
      if (el.__pkNf && el.__pkNf.refine) el.__pkNf.refine.remove();
      document.documentElement.classList.remove('pk-nf-lock');
    });
  });
})();
